module.exports = {
      id: "loading-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#loading",
      toString: function () {
        return this.url;
      }
    }